// PesoBascula.jsx
import React from 'react';
import { gql, useQuery } from '@apollo/client';

const OBTENER_PESO = gql`
  query {
    pesoBascula
  }
`;

function PesoBascula() {
  const { data, loading, error } = useQuery(OBTENER_PESO, {
    pollInterval: 1000, // refrescar cada segundo
  });

  if (loading) return <p>Cargando peso...</p>;
  if (error) return <p>Error al leer la báscula</p>;

  return (
    <div>
      <h2>Peso actual:</h2>
      <p>{data.pesoBascula} kg</p>
    </div>
  );
}

export default PesoBascula;
